module.exports = __webpack_public_path__ + "static/media/cartIconn.79113228.svg";